import { t } from '../../../adapters/translate/translate'
import { customTheme } from '../../../styles/theme'
import { AlertBox } from '../../ui/layout'
import {
  ModalDialogBody, ModalDialogClose,
  ModalDialogContent,
  ModalDialogHeader, ModalDialogHeaderTitle,
  ModalDialogOverlay
} from './modal_box_styled'

const HelpReviewModal = ({ handleClose, isAnonymous }: any) => {
  return (
    <>
      <ModalDialogOverlay onClick={handleClose} />
      <ModalDialogContent>
        <ModalDialogHeader background={customTheme.colors.gray[300]}>
          <ModalDialogHeaderTitle>{t('You are in approval mode')}</ModalDialogHeaderTitle>
          <ModalDialogClose onClick={handleClose}>&times;</ModalDialogClose>
        </ModalDialogHeader>
        <ModalDialogBody>
          <p>{t('Please, leave a review or approve this mission to go ahead :)')}</p>
        </ModalDialogBody>
      </ModalDialogContent>
      <AlertBox />
    </>
  )
}

export default HelpReviewModal
